import { render, staticRenderFns } from "./choseCategory.vue?vue&type=template&id=2c8c33f0&scoped=true"
import script from "./choseCategory.vue?vue&type=script&lang=js"
export * from "./choseCategory.vue?vue&type=script&lang=js"
import style0 from "./choseCategory.vue?vue&type=style&index=0&id=2c8c33f0&prod&lang=css"
import style1 from "./choseCategory.vue?vue&type=style&index=1&id=2c8c33f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c33f0",
  null
  
)

export default component.exports